import { subscriptionStatusTypes } from 'utils/subscription/statusTypes';
import { useActiveLicense } from 'containers/Subscription/hooks';

function useLicenseState() {
  const { data: license } = useActiveLicense();

  return {
    licenseStatus: subscriptionStatusTypes.AVAILABLE,
    licenseState: license,
    licenseValid: true,
    licenseInvalid: false,
    paymentInvalid: false,
    paymentStatus: {
      lastPaymentStatus: license?.lastPaymentStatus,
      paymentIntentsDetail: license?.paymentIntentsDetail,
    },
    serverDateValidate: license?.serverDate,
  };
}
export default useLicenseState;
